export * from "./tenantModule";
import "./tenantService"
import "./nlgTenant"